if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', () => {
            this.setActiveMedia(mediaToSwitch.dataset.target, false, mediaToSwitch.dataset.variantId);
          });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.initThumbnailSpinners();
      }

      connectedCallback() {
        if (this.elements.viewer) {
          requestAnimationFrame(() => this.initMainMediaSpinner());
        }
      }

      initMainMediaSpinner() {
        const activeMedia = this.elements.viewer?.querySelector('.product__media-item.is-active');
        if (!activeMedia) return;
        const spinner = activeMedia.querySelector('.product-media__spinner');
        const img = this.getActiveMediaImage(activeMedia);
        this.hideSpinnerWhenImageLoaded(img, spinner);
      }

      initThumbnailSpinners() {
        this.elements.thumbnails?.querySelectorAll('.thumbnail').forEach((btn) => {
          const img = btn.querySelector('img');
          const spinner = btn.querySelector('.thumbnail__spinner');
          if (!img || !spinner) return;
          this.hideSpinnerWhenImageLoaded(img, spinner);
        });
      }

      hideSpinnerWhenImageLoaded(img, spinner) {
        if (!spinner) return;
        if (!img) {
          spinner.classList.add('hidden');
          return;
        }
        if (img.complete) {
          spinner.classList.add('hidden');
          return;
        }
        spinner.classList.remove('hidden');
        const onLoad = () => {
          spinner.classList.add('hidden');
          img.removeEventListener('load', onLoad);
        };
        img.addEventListener('load', onLoad);
      }

      getActiveMediaImage(mediaItem) {
        return (
          mediaItem.querySelector('.product__media img') ||
          mediaItem.querySelector('.deferred-media__poster img') ||
          mediaItem.querySelector('.deferred-media img')
        );
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, variantId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          element.querySelector('.product-media__spinner')?.classList.add('hidden');
        });
        activeMedia?.classList?.add('is-active');

        if (variantId) {
          this.dispatchEvent(
            new CustomEvent('media-gallery:variant-select', { bubbles: true, detail: { variantId } })
          );
        }

        const mainSpinner = activeMedia.querySelector('.product-media__spinner');
        const mainImg = this.getActiveMediaImage(activeMedia);
        if (mainSpinner) {
          this.hideSpinnerWhenImageLoaded(mainImg, mainSpinner);
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
